<div class="tenant-rule-engine-card rounded-3 bg-white border shadow-sm">
  <div class="d-flex align-items-center justify-content-between gap-3 mb-3">
    <div class="text-uppercase tenant-rule-engine-heading">
      Rule engine &middot; {{ frameworks_count }} risk {{ frameworks_count === 1 ? 'framework' : 'frameworks' }}
    </div>
    <button
      type="button"
      class="btn btn-light btn-sm rounded-small border px-3"
      :disabled="loading_frameworks"
      @click="load_frameworks"
    >
      {{ loading_frameworks ? 'Loading...' : 'Refresh' }}
    </button>
  </div>

  <div
    v-if="loading_frameworks"
    class="tenant-settings-empty-state text-center text-secondary"
  >
    Loading risk frameworks...
  </div>

  <div
    v-else-if="frameworks_error"
    class="tenant-settings-empty-state text-center"
  >
    <div class="text-danger mb-3">{{ frameworks_error }}</div>
    <button type="button" class="btn btn-light btn-sm border px-3" @click="load_frameworks">
      Try again
    </button>
  </div>

  <div
    v-else-if="!frameworks.length"
    class="tenant-settings-empty-state text-center text-secondary"
  >
    No risk frameworks have been configured.
  </div>

  <div v-else class="tenant-rule-engine-table-wrap">
    <table class="tenant-rule-engine-table">
      <thead>
        <tr>
          <th>Risk framework</th>
          <th>Type</th>
          <th>Phase</th>
          <th>Project</th>
          <th>Updated</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="framework in frameworks" :key="framework.id">
          <td>
            <div class="tenant-rule-code">{{ framework.code }} &middot; {{ framework.name }}</div>
            <div class="tenant-rule-copy">{{ framework.description }}</div>
          </td>
          <td>
            <span class="tenant-case-domain-badge is-violet">
              {{ framework.type_label }}
            </span>
          </td>
          <td>
            <code class="tenant-rule-condition">{{ framework.phase_label }}</code>
          </td>
          <td>
            <div class="tenant-rule-action">{{ framework.project_label }}</div>
          </td>
          <td>
            <div class="tenant-rule-action">{{ framework.updated_label }}</div>
          </td>
          <td>
            <span class="tenant-rule-status" :class="framework.status_class">
              {{ framework.status_label }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
